<template>
  <div class="container">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>权益详细</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div class="fbt">
      <div class="fbt_title">剩余权益{{surplus_num}}次</div>
      <div class="fbt_block">
        <div class="fbt_block_item">
          <div class="fbt_block_item_md1">
            尊敬的用户，权益的扣除以自然{{cycle_type}}进行计算，您首次权益的最晚使用截止时间为{{edn_time}}，请尽快使用，权益每{{cycle_type}}可使用一次，如当{{cycle_type}}未使用，权益过期后作废不累积。
          </div>
          <!-- <div v-else-if="free_times==52" class="fbt_block_item_md1">
            尊敬的用户，权益的扣除以自然周进行计算，您首次权益的最晚使用截止时间为{{edn_time}}，请尽快使用，权益每周可使用一次，如当周未使用即权益过期，过期权益作废不累积。
          </div> -->
          <!-- <div class="fbt_block_item_md2">
            注：<br />
            ★ 如您在开卡当月使用首次权益，剩余的权益将于下个月以自然月进行计算，第12次权益有效期为2021年10月1日-10月31日。<br />
            ★ 如您在开卡的次月使用首次权益，第12次权益有效期为2021年11月1日-11月5日。
          </div> -->
        </div>
        <div class="fbt_block_list">
          <div v-for="(item,index) in list" :class="[{'fbt_block_list_blocks':index==0},'fbt_block_list_block']">
            <div class="fbt_block_list_block_title">{{item.year}}年</div>
            <div v-for="(itemtime,indextime) in item.arr" class="fbt_block_list_block_list">
              <label style="display: inline-block;width: 18%;" v-if="itemtime.tab == '' ||itemtime.tab == undefined||itemtime.tab == null"> </label>
              <label style="display: inline-block;width: 18%;" v-else>{{itemtime.tab}}  </label>


              {{(itemtime.begin_date).substring(5,7)}}月{{(itemtime.begin_date).substring(8,10)}}日-{{(itemtime.end_date).substring(5,7)}}月{{(itemtime.end_date).substring(8,10)}}日
              <div v-if="itemtime.tab == '' ||itemtime.tab == undefined||itemtime.tab == null" :class="[{'fbt_status1':itemtime.status==1},{'fbt_status2':itemtime.status==2},{'fbt_status3':itemtime.status==3}]"></div>
              <div v-else :class="[{'fbt_status1':itemtime.status==1},{'fbt_status2':itemtime.status==2},{'fbt_status3':itemtime.status==3}]">{{statusname[itemtime.status]}}</div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {
    getStValStatus
  } from "../../lib/utils.js"
  export default {
    data() {
      return {
        list:[],

        statusname:{
          1:'未使用',
          2:'已使用',
          3:'已过期'
        },
        edn_time:'',
        free_times:0,
        surplus_num:0,
        cycle_type:''
      }
    },
    created() {},
    mounted() {
      console.log(this.$route.params)
      this.free_times=this.$route.params.free_times
      // this.edn_time=this.$route.params.end_date
      this.cardRightLogs()
    },
    methods: {
      cardRightLogs(){
        var $this = this;
        var param = {
          token: localStorage.getItem("token"),
          cards_no: this.$route.params.cards_no
        }
        var qs = require('qs');
        let url = this.api.userApi.bookVipCardsUseLogs
        this.axios.post(url, qs.stringify(param), )
          .then((res) => {
            console.log(res)
            if (res.code == 0) {
              // status:1未使用 2已使用 3已过期
              $this.surplus_num=res.data.surplus_num
              for (let i in res.data.extra) {
                var param={
                  year:i,
                  arr:res.data.extra[i]
                }
                console.log(param)
                $this.list.push(param)
              }
              console.log($this.list)
              $this.edn_time=res.data.first_used_until_date
              $this.cycle_type=res.data.cycle_type
            } else {

            }
          }).catch((error) => {

          })
      },
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .fbt{
    width: 100%;
    height: calc(100vh - 90*@vm_base);
    // border: 1px solid red;
    background-image: url('../../assets/images/base/equity_details_platinum.png');
    background-position: center top;
    background-repeat: no-repeat;
    background-size: 100% auto;
    .fbt_title{
      width: 100%;
      text-align: center;
      font-size: 38*@vm_base;
      font-weight: bold;
      color: #C7C6CC;
      line-height: 42*@vm_base;
      letter-spacing: 1*@vm_base;
      // margin: 0 auto 60*@vm_base auto;
      padding: 80*@vm_base 0 60*@vm_base 0;
    }
    .fbt_block{
      // border: 1px solid blue;
      width: 100%;
      height: calc(100vh - 304*@vm_base);
      overflow: hidden;
      overflow-y: auto;
      padding: 0 32*@vm_base;
      .fbt_block_item{
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0px 10*@vm_base 30*@vm_base 0px rgba(0, 0, 0, 0.1);
        border-radius: 12*@vm_base;
        padding: 40*@vm_base;
        margin-bottom: 30*@vm_base;
        .fbt_block_item_md1{
          font-size: 28*@vm_base;
          font-weight: 400;
          color: #444054;
          line-height: 40*@vm_base;
        }
        .fbt_block_item_md2{
          font-size: 28*@vm_base;
          font-weight: 400;
          color: #444054;
          line-height: 40*@vm_base;
          margin-top: 20*@vm_base;
        }
      }
      .fbt_block_list{
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0px 10*@vm_base 30*@vm_base 0px rgba(0, 0, 0, 0.1);
        border-radius: 12*@vm_base;
        padding: 0 0 40*@vm_base 0;
        margin-bottom: 30*@vm_base;
        .fbt_block_list_block{
          width: 100%;

          .fbt_block_list_block_title{
            padding: 8*@vm_base 40*@vm_base;
            width: 100%;
            // height: 60px;
            // line-height: 60*@vm_base;
            background: #F8F8F8;
            font-size: 32*@vm_base;
            font-weight: bold;
            color: #444054;
            letter-spacing: 1px;
            margin-bottom: 30*@vm_base;
          }
          .fbt_block_list_block_list{
            width: 100%;
            padding: 0 40*@vm_base;
            font-size: 24*@vm_base;
            font-weight: 400;
            color: #444054;
            line-height: 33*@vm_base;
            letter-spacing: 2*@vm_base;
            margin-bottom: 16*@vm_base;
            div{
              float: right;
              line-height: 33*@vm_base;
              font-weight: 400;
              line-height: 33*@vm_base;
              letter-spacing: 2*@vm_base;
            }
            .fbt_status1{
              color: #3678E1;
            }
            .fbt_status2{
              color: #444054;
            }
            .fbt_status3{
              color: #B4B3BB;
            }
          }
        }
        .fbt_block_list_blocks{
          padding-top: 40*@vm_base;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/vip/freeBenefitTime.vue